module.exports = __webpack_public_path__ + "static/media/SeventhGeneration.ad5db314.png";